import { Reveal } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

const FAQS = [
  {
    q: "La mediazione familiare sostituisce l'avvocato?",
    a: "No. La mediazione non sostituisce l'assistenza legale, la affianca. Gli accordi raggiunti in mediazione possono essere recepiti dai vostri legali e omologati dal Tribunale, arrivando però più in fretta e con molta meno conflittualità.",
  },
  {
    q: "Quanto dura l'intero percorso?",
    a: "In media da 8 a 12 incontri di circa un'ora e mezza ciascuno, distribuiti in 3–5 mesi. Molto meno dei tempi di una causa di separazione giudiziale, che può durare anni.",
  },
  {
    q: "Cosa succede se l'altro genitore non vuole partecipare?",
    a: "Si può iniziare con un colloquio informativo individuale. In seguito, il mediatore può rivolgere all'altro genitore un invito formale e riservato. La partecipazione resta volontaria per entrambi.",
  },
  {
    q: "Quello che diciamo negli incontri resta riservato?",
    a: "Sì, sempre. Tutto il percorso è coperto da assoluta riservatezza: i contenuti degli incontri non possono essere usati in tribunale e il mediatore non può essere chiamato a testimoniare (art. 337-octies c.c.).",
  },
  {
    q: "Quanto costa?",
    a: "Il primo colloquio è informativo e senza impegno. Gli incontri successivi hanno una tariffa chiara, comunicata per iscritto prima di iniziare. Complessivamente, i costi sono indicativamente fino all'80% inferiori a quelli di un contenzioso legale.",
  },
  {
    q: "L'accordo raggiunto ha valore legale?",
    a: "L'accordo di mediazione è un documento serio e vincolante tra le parti. Può essere trasmesso ai legali e omologato dal Tribunale, acquisendo piena efficacia giuridica nell'ambito del procedimento di separazione o divorzio.",
  },
];

export const FaqAccordion = () => (
  <section id="faq" data-testid="faq-accordion" className="py-20 lg:py-32 bg-sand border-y border-ink/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
      <Reveal className="lg:col-span-4">
        <div className="lg:sticky lg:top-28">
          <p className="overline-tag mb-4">Domande frequenti</p>
          <h2 className="font-serif font-semibold text-ink tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight">
            Le risposte che cerchi, senza giri di parole.
          </h2>
          <p className="mt-5 text-base text-mist leading-relaxed">
            Se non trovi la tua domanda, scrivimi: il primo colloquio serve proprio a chiarire i dubbi,
            senza alcun impegno.
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.15} className="lg:col-span-8">
        <Accordion type="single" collapsible className="flex flex-col gap-3">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`}
              className="bg-white border border-ink/10 rounded-xl px-6 data-[state=open]:border-gold/60 transition-colors duration-300">
              <AccordionTrigger data-testid={`faq-trigger-${i}`}
                className="text-left font-serif font-semibold text-ink text-base sm:text-lg py-5 hover:text-golddeep hover:no-underline [&[data-state=open]>svg]:text-golddeep">
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="text-sm sm:text-base text-mist leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
